<template>
  <banner :flag-name="flagName" @dismiss="showBanner = false" v-if="shouldShowBanner" dismissible>
    <div class="flex-center flex-gap-14 text-medium-1">
      Need help understanding North?
      <request-demo-link :org-id="orgId" />
      <a class="text-gradient hoverable bold" @click="showDemoOrgModal = true">
        Try a demo account
      </a>
    </div>
    <demo-org-modal v-model="showDemoOrgModal" v-if="showDemoOrgModal" />
  </banner>
</template>

<script>
import Banner from '@/components/Banner.vue'
import DemoOrgModal from '@/components/demoOrg/DemoOrgModal.vue'
import RequestDemoLink from '@/components/RequestDemoLink.vue'
import { STORAGE_FLAGS } from '@/constants/storage'
import { storageFlags } from '@/utils/storageUtils'

export default {
  name: 'NeedHelpBar',
  props: ['orgId'],
  components: { RequestDemoLink, DemoOrgModal, Banner },
  data() {
    return {
      flagName: STORAGE_FLAGS.needHelpBannerDismissed,
      showBanner: !storageFlags.get(STORAGE_FLAGS.needHelpBannerDismissed),
      showDemoOrgModal: false
    }
  },
  computed: {
    isNewUser() {
      const user = this.$store.getters.user
      const userCreationDate = new Date(user.createdAt)
      const now = new Date()
      const dayDiff = (now - userCreationDate) / (1000 * 60 * 60 * 24)
      return dayDiff < 30
    },
    shouldShowBanner() {
      return this.showBanner && this.isNewUser
    }
  },
  methods: {},
  mounted() {}
}
</script>

<style lang="scss" scoped></style>
